<script lang="ts">
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';

    let { browser: wiring } = $derived(injectWiring());
</script>

<!--/static-proxy/dundee/sheets/rating_sheet_text.html-->
<oc-sheet-v1
    id="reptile-ratings-sheet"
    headline="So funktionieren unsere Kundenbewertungen"
    base64-url="L3N0YXRpYy1wcm94eS9kdW5kZWUvc2hlZXRzL3JhdGluZ19zaGVldF90ZXh0Lmh0bWw="
    onoc-sheet-open={() => {
        wiring?.trackingService.trackListLayer('rating');
    }}
></oc-sheet-v1>
<!--/static-proxy/dundee/sheets/rating_sheet_detail_text.html-->
<oc-sheet-v1
    id="reptile-ratings-detail-sheet"
    headline="Richtlinien für Bewertungen"
    base64-url="L3N0YXRpYy1wcm94eS9kdW5kZWUvc2hlZXRzL3JhdGluZ19zaGVldF9kZXRhaWxfdGV4dC5odG1s"
></oc-sheet-v1>
